module.exports = __webpack_public_path__ + "img/TurningStool0.2438822b.jpg";